var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1551 1.54044V1.53852C16.1551 1.11367 15.8107 0.769287 15.3859 0.769287H4.60126C4.17642 0.769287 3.83203 1.11367 3.83203 1.53852V1.54044C3.83203 1.96529 4.17642 2.30967 4.60126 2.30967H15.3859C15.8107 2.30967 16.1551 1.96529 16.1551 1.54044ZM4.6128 19.2308H15.3974C15.8223 19.2308 16.1666 18.8864 16.1666 18.4616V18.4597C16.1666 18.0348 15.8223 17.6904 15.3974 17.6904H4.6128C4.18795 17.6904 3.84357 18.0348 3.84357 18.4597V18.4616C3.84357 18.8864 4.18795 19.2308 4.6128 19.2308ZM5.36695 14.6058V16.9231H14.6093V14.6058C14.6093 12.0565 12.5451 9.98467 9.98811 9.98467C7.43872 9.98467 5.36695 12.0565 5.36695 14.6058ZM14.6093 5.36352V3.07706H5.36695V5.36352C5.36695 7.92059 7.43872 9.98467 9.98811 9.98467C12.5451 9.98467 14.6093 7.92059 14.6093 5.36352Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.84d6734eaf875685872cd89a2cc7cc83.svg";
export { ForwardRef as ReactComponent };